/*
 *  ~ Copyright (c) by INFODATA-GROUP. All rights reserved.
 *  ~ No part of this publication may be reproduced, distributed,
 *  ~ or transmitted in any form or by any means, including photocopying, recording,
 *  ~ or other electronic or mechanical methods, without the prior written permission of the publisher,
 *  ~ except in the case of brief quotations embodied in critical
 *  ~ reviews and certain other noncommercial uses permitted by copyright law.
 *  ~ Author : BS
 *  ~ Date : 2/8/23, 5:52 PM
 */

import { Entity } from '@infodata-group/inf-commons';

export class Bbx extends Entity {
  public bbxId: string;
  public bbxLabel: string;
  public bbxGroupId: string;
  public bbxKm: number;
  public bbxDeviceId: string;
  public bbxDeviceLib: string;
  public bbxIsSpeedNull: string;
  public bbxSpeedNullTime: string;
  public bbxSpeedNullKm: string;
  public bbxEngine: boolean;
  public bbxPicture = 'car';
  public bbxEcoId: string;
  public bbxEnt: string;
  public bbxNf: string;
  public bbxMod: string;
  public bbxFab: string;
  public bbxGsm: string;
  public bbxPin: string;
  public bbxIMEI: string;
  public bbxSoft: string;
  public lowEngin: number;
  public highEngin: number;

  public override lock: boolean;

  constructor() {
    super();
  }

  getId(): string {
    return this.bbxId;
  }

  getLabel(): string {
    return this.bbxLabel;
  }

  serialize() {
    return {
      bbxId: this.bbxId,
      bbxLabel: this.bbxLabel,
      bbxGroupId: this.bbxGroupId,
      bbxKm: this.bbxKm,
      bbxDeviceId: this.bbxDeviceId,
      bbxDeviceLib: this.bbxDeviceLib,
      bbxIsSpeedNull: this.bbxIsSpeedNull,
      bbxSpeedNullTime: this.bbxSpeedNullTime,
      bbxSpeedNullKm: this.bbxSpeedNullKm,
      bbxEngine: this.bbxEngine,
      bbxPicture: this.bbxPicture,
      bbxEcoId: this.bbxEcoId,
      bbxEnt: this.bbxEnt,
      bbxNf: this.bbxNf,
      bbxMod: this.bbxMod,
      bbxFab: this.bbxFab,
      bbxGsm: this.bbxGsm,
      bbxPin: this.bbxPin,
      bbxIMEI: this.bbxIMEI,
      bbxSoft: this.bbxSoft,
    };
  }

  public override toString(): string {
    return JSON.stringify(this.serialize());
  }
}
